import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiOnboardingReportSharedModule } from '../shared/fi-onboarding-report-shared.module';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';
import { FiOnboardingReportWidgetDetailsComponent } from './fi-onboarding-report-details.component';
import { FiTotalOnboardingsTableComponent } from './total-onboardings/details-table/fi-total-onboardings-table.component';
import { FiTotalOnboardingsDetailsComponent } from './total-onboardings/fi-total-onboardings-details.component';
import { FiOnboardingReportLocationsWidgetComponent } from './locations-widget/fi-onboarding-report-locations-widget.component';
import { FiOnboardingReportLocationsWidgetTableComponent } from './locations-widget/details-table/fi-onboarding-report-locations-widget-table.component';
import { FiOnboardingReportParticipantsWidgetComponent } from './participants-widget/fi-onboarding-report-participants-widget.component';
import { FiOnboardingReportParticipantsWidgetTableComponent } from './participants-widget/details-table/fi-onboarding-report-participants-widget-table.component';
import { FiOnboardingReportParticipantsOnboardedWidgetComponent } from './participants-onboarded-widget/fi-onboarding-report-participants-onboarded-widget.component';
import { FiOnboardingReportParticipantsOnboardedWidgetTableComponent } from './participants-onboarded-widget/details-table/fi-onboarding-report-participants-onboarded-widget-table.component';
import { MatCardModule } from '@angular/material/card';
import { FiTwoColumnsContainerModule } from '@fi-app/shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiProgressBadgeModule } from '@fi-app/shared/fi-progress-badge/fi-progress-badge.module';
import { FiGradientCircleModule } from '@fi-shared/fi-gradient-circle/fi-gradient-circle.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { MatIconModule } from '@angular/material/icon';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FiWrapperTableModule,
        MatTableModule,
        MatSortModule,
        MatCardModule,
        FiAppTextSharedModule,
        FiOnboardingReportSharedModule,
        FiReportWidgetModule,
        FiTwoColumnsContainerModule,
        FiProgressBadgeModule,
        FiGradientCircleModule,
        FiFormatDateModule,
        FiTooltipModule,
        MatIconModule,
        FiWhenScrolledModule,
        MatButtonModule,
        FormsModule,
    ],
    declarations: [
        FiOnboardingReportWidgetDetailsComponent,
        FiTotalOnboardingsTableComponent,
        FiTotalOnboardingsDetailsComponent,
        FiOnboardingReportLocationsWidgetComponent,
        FiOnboardingReportLocationsWidgetTableComponent,
        FiOnboardingReportParticipantsWidgetComponent,
        FiOnboardingReportParticipantsWidgetTableComponent,
        FiOnboardingReportParticipantsOnboardedWidgetComponent,
        FiOnboardingReportParticipantsOnboardedWidgetTableComponent,
    ],
    exports: [
        FiOnboardingReportWidgetDetailsComponent,
        FiTotalOnboardingsDetailsComponent,
        FiOnboardingReportParticipantsOnboardedWidgetComponent,
    ]
})
export class FiOnboardingReportDetailsModule {}
